/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxProfessionalSingleTapTowerKitComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalSingleTapTowerKit').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'SINGLE_TAP_TOWER_KIT_L24TWS',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'default', true).withEntity('LynxProfessionalSingleTapTowerKit').attach(memoEval((self)=>[
            self.$offsetY
        ], ($offsetY)=>({
            offsetY: $offsetY
        })))
];

//# sourceMappingURL=lynx-professional-single-tap-tower-kit.js.map